import { EntityType } from "@mapmycustomers/shared/enum";

import GlobalSearchItemType from "@app/enum/GlobalSearchItemType";
import GlobalSearchItem, {
  AddressGlobalSearchItem,
  GlobalSearchEntity,
  GlobalSearchGroup,
  SavedLocationGlobalSearchItem,
  SetSavedLocationGlobalSearchItem,
} from "@app/types/globalSearch/GlobalSearchItem";

export const isSearchGroup = (
  searchEntity: GlobalSearchEntity
): searchEntity is GlobalSearchGroup =>
  !!searchEntity.entity &&
  [EntityType.COMPANY_GROUP, EntityType.DEAL_GROUP, EntityType.PEOPLE_GROUP].includes(
    searchEntity.entity
  );

export const isSavedLocationGlobalSearchItem = (
  item: GlobalSearchItem
): item is SavedLocationGlobalSearchItem => item.type === GlobalSearchItemType.SAVED_LOCATION;

export const isSetSavedLocationGlobalSearchItem = (
  item: GlobalSearchItem
): item is SetSavedLocationGlobalSearchItem =>
  item.type === GlobalSearchItemType.SET_SAVED_LOCATION;

export const isAddressGlobalSearchItem = (
  item: GlobalSearchItem
): item is AddressGlobalSearchItem => item.type === GlobalSearchItemType.ADDRESS;
